export default {
  store: {
    display: 'flex',
    justifyContent: 'center',
  },
  saveButton: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'fixed',
    right: '5%',
  },
  spinner: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    marginBottom: 5,
  },
  repairIcon: {
    marginBottom: 10,
  },
};
